<template>
  <v-content>
    <v-container fluid>
      <Header :title="title" />
      <v-row no-gutters>
        <v-col cols="12">
           <v-tabs
            v-model="tabs"
          >
              <v-tabs-slider></v-tabs-slider>
              <v-tab v-if="canAddSystem" href="/system-email-template"> {{ 'System Emails' | translate}} </v-tab>
              <v-tab v-if="canAddScheduled" href="/scheduled-mail-notification"> {{ 'Scheduled Mails' | translate}} </v-tab>
              <v-tab v-if="canAddTrigger" href="/trigger-mail-template"> {{ 'Trigger Mails' | translate }} </v-tab>
              <v-tab v-if="canAdd" href="#viewremindertab" active> {{ 'Reminder Mails' | translate }} </v-tab>
          </v-tabs>

          <DataTable
            @editing="editing"
            @deleting="deleting"
            :title="''"
            :headers="headers"
            :items="reminderemail"
            :search="search"
          />
        </v-col>
        <Dialogbox
          @closing="closing"
          @deleteuser="deleteReminderEmail"
          :title="dialogboxtitle"
          :dialog="dialogstatus"
          :buttonTitle="dialogButtontitle"
          :deleteuser="true"
          v-if="dialogstatus"
        />
      </v-row>
    </v-container>
    <v-btn dark fab fixed bottom right large color="pink" class="mx-2" v-if="canAdd" @click="addReminderEmail">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </v-content>
</template>
<script>
import { mapGetters } from "vuex"
import store from "@/store"
import {
  FETCH_REMINDER_EMAIL_TEMPLATE,
  DELETE_REMINDER_EMAIL_TEMPLATE,
  RESET_STATE
} from "@/store/actions.type";
import { SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type"
export default {
  name: "ReminderEmail",
  beforeRouteEnter(to, from, next) {
    store.dispatch(RESET_STATE)
    store.dispatch(FETCH_REMINDER_EMAIL_TEMPLATE, "").then(resp => {
      if (resp.success) {
        store.commit(SET_LOADING, false)
        store.commit(SET_ROUTER_ENTER, false)
      }
    });
    return next();
  },
  beforeRouteLeave(to, from, next) {
    store.dispatch(RESET_STATE)
    next();
  },
  data: function() {
    return {
      title: "Reminder",
      search: "",
      dialogstatus: false,
      dialogButtontitle: null,
      dialogboxtitle: null,
      reminderemailid: null,
      singleSelect: "",
      dialog: false,
      tabs: "viewremindertab"
    };
  },
  components: {
    DataTable: () => import("@/components/datatable/datatable"),
    Dialogbox: () => import("@/components/dialog/dialog"),
    Header: () => import("@/components/header/Header")
  },
  computed: {
    ...mapGetters(["reminderemail",'currentUser']),
    headers () {
      return [
        { text: this.$t("Email Template id"), value: "rm_temp_id" },  
        { text: this.$t("Template Name"), value: "reminder_template_name" },        
        { text: this.$t("Reminder Event"), value: "reminder_event" },        
        { text: this.$t("Reminder After Every"), value: "on_every" },        
        { text: this.$t("Cycles"), value: "cycles" },        
        { text: this.$t("Start Date"), value: "start_date" },        
        { text: this.$t("Start Time"), value: "start_time" },        
        { text: this.$t("Actions"), value: "action", sortable: false },
      ]
    },
    canAdd(){
      if(typeof (this.currentUser) !== 'undefined') {
        if(this.currentUser.roles.includes(1) || this.currentUser.permissions.includes('has-access-to-reminder-mails')){
          return true;
        }
      }
      return false;
    },
    canAddSystem(){
      if(typeof (this.currentUser) !== 'undefined') {
        if(this.currentUser.roles.includes(1) || this.currentUser.permissions.includes('has-access-to-system-mails')){

          return true;
        }
      }
      return false;
    },
    canAddScheduled(){
      if(typeof (this.currentUser) !== 'undefined') {
        if(this.currentUser.roles.includes(1) || this.currentUser.permissions.includes('has-access-to-scheduled-mails')){

          return true;
        }
      }
      return false;
    },
    canAddTrigger(){
      if(typeof (this.currentUser) !== 'undefined') {
        if(this.currentUser.roles.includes(1) || this.currentUser.permissions.includes('has-access-to-trigger-mails')){

          return true;
        }
      }
      return false;
    },
  },
  created (){
    if(!this.hasrequiredPermissions()){
      this.$router.push('/dashboard');
    }
  },
  methods: {
    hasrequiredPermissions(){
      if(this.currentUser.roles.includes(1) == true || this.currentUser.permissions.includes('has-access-to-reminder-mails') ){
        return true;
      }
      return false;
    },
    addReminderEmail() {
      this.$router.push("/reminder/add");
    },
    editing(id) {
      this.$router.push("/reminder/edit/" + id)
    },
    deleting(id) {
      this.dialogstatus = true
      this.dialogboxtitle = "Are you sure want to remove?"
      this.dialogButtontitle = "Remove"
      this.reminderemailid = id
    },
    async deleteReminderEmail() {
      await this.$store
        .dispatch(DELETE_REMINDER_EMAIL_TEMPLATE, this.reminderemailid)
        .then(async resp => {
          if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
            this.reminderemailid = null;
            await store.dispatch(FETCH_REMINDER_EMAIL_TEMPLATE, "").then(resp => {
              if (resp.success) {
                store.commit(SET_LOADING, false);
                this.dialogstatus = false;
              }
            });
          }
          else{
            store.commit(SET_LOADING, false);
          }
        });
    },
    closing() {
      this.dialogstatus = false
    },
  }
};
</script>